<div class="home-load flex-col" [ngClass]="{ 'dashboard-load': isDashboard }">
    <div class="flex-row row">
        <div class="box-sized col-xs-12 col-md-5"></div>
        <div class="box-sized col-xs-12 col-md-3"></div>
        <div class="box-sized col-xs-12 col-md-3"></div>
    </div>

    <div class="row">
        <div class="box-extended col-md-12"></div>
        <div class="box-extended col-md-12"></div>
        <div class="box-extended col-md-12"></div>
    </div>
</div>